// extracted by mini-css-extract-plugin
export default {"menuBlock":"bG-z","title":"cG-z","nav":"dG-z","flexCell":"eG-z","facetLink":"fG-z"};